var map = {
	"./chevron-top.svg": 3272,
	"./git-stroke.svg": 8182,
	"./git.svg": 1199,
	"./line.svg": 9350,
	"./link-external.svg": 9058,
	"./link.svg": 4008,
	"./mail.svg": 7896,
	"./moon.svg": 749,
	"./nuxt-stroke.svg": 5933,
	"./nuxt.svg": 5731,
	"./sass-stroke.svg": 2171,
	"./sass.svg": 9560,
	"./sun.svg": 5843,
	"./vue-stroke.svg": 2460,
	"./vue.svg": 2010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;